import { Box, useTheme } from "@mui/material"
import BaseCard from "../../../theme/cards/BaseCard"
import Text from "../../../theme/text/Text";
import CardLabel from "../../../theme/label/CardLabel";
import TopRight from "../../../theme/positionals/TopRight";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import { useTranslation } from "react-i18next";
import { getInboundStateData } from "../../../../utils/labelColorText";

export const RelationInboundLineCard = (props) => {
    const theme = useTheme();
    const { t,i18n } = useTranslation();

    let status = props.state;
    

    const { labelcolor, labeltext } = getInboundStateData(props.state, theme, props.incompleteReceived);

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box>
                    <Box>
                        {props.skeleton ?
                            <ShTextSkeleton/> 
                            :
                            <Text bold>{props.inbound.reference}</Text>
                        }
                    </Box>

                    <Box
                        sx={{
                            mt:4,
                            display:"flex",
                            flexDirection:"column"
                        }}
                    >
                        {props.skeleton ?
                            <ShTextSkeleton/> 
                            :
                            <>
                                <Text>{props.product.sku}</Text>
                                <Text light>{props.product.description}</Text>
                            </>
                        }
                    </Box>

                    <TopRight>
                        <CardLabel hasright variant={labelcolor} position="child-tr">
                            {t(labeltext)}
                        </CardLabel>
                        <CardLabel 
                            variant={theme.palette.mode === "dark" ? "greyLight" : "grey"}
                            hasleft 
                            fitted
                            colorflip={theme.palette.mode !== "dark"}
                            position="child-tr"
                        >
                            {props.skeleton ? "N/A" : props.amountForecasted}
                        </CardLabel>
                    </TopRight>
                </Box>
            </Box>
        </BaseCard>
    )
}

export const WarehouseInboundLineCard = (props) => {
    const theme = useTheme();
    const { t,i18n } = useTranslation();

    let status = props.state;
    let labelcolor = theme.palette.mode === "dark" ? "greyLight" : "grey";
    let labeltext = t('unknown');
    switch(status){
        case "notreceived":
            labelcolor = theme.palette.mode === "dark" ? "greyLight" : "grey"
            labeltext = t('not_received');
            break;
        case "partlyreceived":
            labelcolor = "blue"
            labeltext = t('partly_received');
            break;
        case "fullyreceived":
            labelcolor = "green"
            labeltext = t('fully_received');
            break;
        default:
            labelcolor = "red"
            labeltext = t('unknown');
            break;
    }

    // A line closed with less received than forecasted is shown as a shortage, not as fully received
    if (props.incompleteReceived) {
        labelcolor = "red";
        labeltext = t('incomplete_received');
    }

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box>
                    <Box>
                        {props.skeleton ?
                            <ShTextSkeleton/> 
                            :
                            <Text bold>{props.inbound.reference}</Text>
                        }
                    </Box>

                    <Box
                        sx={{
                            mt:4,
                            display:"flex",
                            flexDirection:"column"
                        }}
                    >
                        {props.skeleton ?
                            <ShTextSkeleton/> 
                            :
                            <>
                                <Text>{props.product.sku}</Text>
                                <Text light>{props.product.description}</Text>
                            </>
                        }
                    </Box>

                    <TopRight>
                        <CardLabel hasright variant={labelcolor} position="child-tr">
                            {labeltext}
                        </CardLabel>
                        <CardLabel 
                            fitted
                            variant={theme.palette.mode === "dark" ? "greyLight" : "grey"}
                            hasleft 
                            colorflip={theme.palette.mode !== "dark"}
                            position="child-tr"
                        >
                            {props.skeleton ? "N/A" : props.amountForecasted}
                        </CardLabel>
                    </TopRight>
                </Box>
            </Box>
        </BaseCard>
    )
}
